import React from 'react';
import styled from "styled-components";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  font-size: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
  color: #cccccc;
`;

export function FullWidthLoader() {
  return (
    <LoaderWrapper>
      <FontAwesomeIcon icon={faCircleNotch} spin />
    </LoaderWrapper>
  )
}